import FiveOThree from '@src/app/503';
import FourOFour from '@src/app/not-found';
import type { IDRepDetails } from '@src/models/dtos/metadata';
import DRepProfileContainer from '@src/container/dRepProfileContainer';
import type { SeoVotes } from '@src/lib/seo/votes';

interface ProfileWrapperProps {
  fromDRepId?: boolean;
  dRepDetails: IDRepDetails;
  seoVotes?: SeoVotes;
}

export default function ProfileWrapper({
  fromDRepId = false,
  dRepDetails,
  seoVotes,
}: ProfileWrapperProps) {
  if (dRepDetails.errorCode === 503) return <FiveOThree />;

  if (!dRepDetails.dRep && !dRepDetails.token) {
    return <FourOFour />;
  }
  return (
    <DRepProfileContainer
      dRepDetails={dRepDetails}
      fromDRepId={fromDRepId}
      seoVotes={seoVotes}
    />
  );
}
